// Chiave di provide/inject con cui un GlassPanel dice ai pannelli che contiene di non sfocare a loro volta.
export const CHIAVE_LIVELLO_VETRO = "livelloVetro";
